// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const transformValidationErrors = (errors: any) => {
  const newErrors = {};
  if (errors) {
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in errors) {
      // eslint-disable-next-line prefer-destructuring
      // @ts-ignore
      // eslint-disable-next-line prefer-destructuring
      newErrors[key] = errors[key][0];
    }
  }
  return newErrors;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const transformResponseValErrors = (error: any) =>
  transformValidationErrors(error?.response?.data.errors);
